import { Typography } from "@mui/material";
import { getPlatformDisplayName } from "@/utils/social.ts";
import type { Network } from "@commercial-publishing/shared-types/social";

interface LinksProps {
  linksPerPlatform: {
    link: string;
    platform: Network;
  }[];
}

export const Links = ({ linksPerPlatform }: LinksProps) => {
  if (!linksPerPlatform || linksPerPlatform.length === 0) {
    return <Typography variant="body2">No links available</Typography>;
  }

  return (
    <div>
      {linksPerPlatform.map(({ link, platform }, index) => (
        <div key={`${platform}-${index}`}>
          <Typography variant="body2" component="span">
            <strong>{getPlatformDisplayName(platform)}: </strong>
            <a
              href={link}
              target="_blank"
              rel="noreferrer"
              onClick={(e) => e.stopPropagation()}
            >
              {link}
            </a>
          </Typography>
        </div>
      ))}
    </div>
  );
};
